import { useOpenModal } from 'utils/modals';

import { SmsAppModals } from './types';

export const useOpenStartConversationModal = () =>
  useOpenModal(SmsAppModals.START_CONVERSATION);

